import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "e6f2c557-cf28-4834-afd0-f29b2cd0f062",
    options: { imageUrl: `${config.ASSETS_URL}/02/13/task/task-3-item-1.svg` },
  },
  {
    id: "cf1b9445-9b10-4fba-9df4-dce6fa2cca71",
    options: { imageUrl: `${config.ASSETS_URL}/02/13/task/task-3-item-2.svg` },
  },
  {
    id: "df0f6c7d-f6fe-4d8b-b498-124d17800287",
    options: { imageUrl: `${config.ASSETS_URL}/02/13/task/task-3-item-3.svg` },
  },
  {
    id: "60225104-e987-4a14-ae4d-c72d36e1251b",
    options: { imageUrl: `${config.ASSETS_URL}/02/13/task/task-3-item-4.svg` },
  },
];

const groups = [
  {
    id: "b48e80eb-4f5a-48bf-8a85-0c7886ccfd5f",
    options: { imageUrl: `${config.ASSETS_URL}/02/13/task/task-3-group-1.svg` },
  },
  {
    id: "ec3d239d-6bad-48e5-8308-2756de2941c7",
    options: { imageUrl: `${config.ASSETS_URL}/02/13/task/task-3-group-2.svg` },
  },
  {
    id: "8acd4a7d-59b9-4868-a398-001922d67485",
    options: { imageUrl: `${config.ASSETS_URL}/02/13/task/task-3-group-3.svg` },
  },
  {
    id: "f93bf43f-e275-4f44-af1f-a6b4965fc38b",
    options: { imageUrl: `${config.ASSETS_URL}/02/13/task/task-3-group-4.svg` },
  },
];

export const task: Task = {
  id: "a21851af-11c6-4813-ba9e-3bd4bef526cf",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: false,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "b48e80eb-4f5a-48bf-8a85-0c7886ccfd5f", itemsId: ["cf1b9445-9b10-4fba-9df4-dce6fa2cca71"] },
    { groupId: "ec3d239d-6bad-48e5-8308-2756de2941c7", itemsId: ["df0f6c7d-f6fe-4d8b-b498-124d17800287"] },
    { groupId: "8acd4a7d-59b9-4868-a398-001922d67485", itemsId: ["60225104-e987-4a14-ae4d-c72d36e1251b"] },
    { groupId: "f93bf43f-e275-4f44-af1f-a6b4965fc38b", itemsId: ["e6f2c557-cf28-4834-afd0-f29b2cd0f062"] },
  ],
};
